import * as React from 'react';

import * as styles from './styles/error_button.css';
import { Button, IButtonProps } from '../../../base/Button';

export interface IErrorButtonProps extends IButtonProps {
  callback?(): void;
}

export function ErrorButton(props: IErrorButtonProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { callback, children, type, ...rest } = props;

  return (
    <Button className={styles['error_button']} {...rest} onClick={callback}>
      {children}
    </Button>
  );
}
